import { render, staticRenderFns } from "./FichajeAutomaticoFormulario.vue?vue&type=template&id=a66e4c54&scoped=true&"
import script from "./FichajeAutomaticoFormulario.vue?vue&type=script&lang=ts&"
export * from "./FichajeAutomaticoFormulario.vue?vue&type=script&lang=ts&"
import style0 from "./FichajeAutomaticoFormulario.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FichajeAutomaticoFormulario.vue?vue&type=style&index=1&id=a66e4c54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66e4c54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDialog,VIcon,VImg,VSelect,VTextField})
